export default "__VITE_ASSET__PXSB52h1__"